import React, { forwardRef, useImperativeHandle, useState } from "react";
import BaseImport from "./index";

const BaseImportModal = forwardRef(({ importData, apiURL }, ref) => {
  const [show, setShow] = useState(false);
  useImperativeHandle(ref, () => ({
    open: () => {
      setShow(true);
    },
    close: () => {
      setShow(false);
    },
  }));

  return (
    <BaseImport
      setShow={setShow}
      show={show}
      api={apiURL}
      {...importData}
    />
  );
});

export default BaseImportModal;
